package com.dignicate.web.viewmodels

import com.dignicate.web.domain.DocumentContent
import com.dignicate.web.domain.GetPrivacyPolicyUseCase
import com.dignicate.web.domain.Resource
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

sealed interface PrivacyUiState {
    object Loading : PrivacyUiState
    data class Ready(val content: DocumentContent) :
        PrivacyUiState
    data class Error(val message: String) : PrivacyUiState
}

class PrivacyPolicyViewModel(
    private val getPrivacyPolicyUseCase: GetPrivacyPolicyUseCase
) : ViewModel() {

    private val _uiState = MutableStateFlow<PrivacyUiState>(PrivacyUiState.Loading)
    val uiState: StateFlow<PrivacyUiState> = _uiState.asStateFlow()

    init {
        // subscribe to usecase data
        viewModelScope.launch {
            getPrivacyPolicyUseCase.data.collect { resource ->
                _uiState.value = when (resource) {
                    is Resource.Initialized -> PrivacyUiState.Loading
                    is Resource.InProgress -> PrivacyUiState.Loading
                    is Resource.Success<DocumentContent> -> PrivacyUiState.Ready(resource.data)
                    is Resource.Failure -> PrivacyUiState.Error(resource.error.message)
                }
            }
        }
    }

    override fun onCreated() {
        super.onCreated()
        viewModelScope.launch {
            getPrivacyPolicyUseCase.fetch()
        }
    }
}
